// @ts-nocheck
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";

export default {
    name: "availableCountries",
    displayName: "Supported Countries",
    editorTemplate: "ListField",
    getDisplay: ({ fields: { name } }) => name,
    fieldType: "General",
    fieldDefinitions: [
        {
            name: "name",
            editorTemplate: "TextField",
            defaultValue: "",
        },
        {
            name: "abbreviation",
            editorTemplate: "TextField",
            defaultValue: "",
        },
    ],
    defaultValue: [
        {
            fields: { name: "Canada", abbreviation: "CA" },
        },
        {
            fields: { name: "Mexico", abbreviation: "MX" },
        },
        {
            fields: { name: "United States of America", abbreviation: "USA" },
        },
    ],
} as FieldDefinition;
